import React from "react";
import "./QuestionareNext.css";

const QuestionareNext = ({ currentStep, setCurrentStep, canProceed, setErrorQuestions, isInError, missingAnsw }) => {
  if (missingAnsw === 12) {
    missingAnsw = 11;
  } else if (missingAnsw === 11) {
    missingAnsw = 12;
  }
  return (
    <div className="questionareNext_container">
      <div
        className={
          "next_btn_questionare" +
          (canProceed ? "" : " quest_procc_disabled") +
          (currentStep === 3 ? " next_btn_consent" : "")
        }
        onClick={() =>
          canProceed ? setCurrentStep(currentStep < 4 ? currentStep + 1 : currentStep) : setErrorQuestions(true)
        }
      >
        {currentStep === 3 ? "Continue" : "Next"}
        <div className="next_btn_tooltip">
          <div className="next_btn_tooltip_inner">
            <div className="next_btn_tooltip_text">Please answer all the questions to continue</div>
            <div className="next_btn_arrow"></div>
          </div>
        </div>
      </div>
      {isInError && !canProceed && currentStep !== 3 ? (
        <div className="question_not_answered">
          <div className="question_error_img"></div>
          <div className="question_error_msg">
            Please answer all the questions. Looks like you’ve missed question #{missingAnsw}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default QuestionareNext;
